// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__l4kO-","title":"ClientInsurance_title__3sNCY","itemText":"ClientInsurance_itemText__1cu9G"};